"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

const IconCamera = (_ref) => {
  let {
    svgRef,
    title
  } = _ref,
      props = (0, _objectWithoutProperties2.default)(_ref, ["svgRef", "title"]);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: "1em",
    height: "1em",
    fill: "currentColor",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), title ? /*#__PURE__*/_react.default.createElement("title", null, title) : null, /*#__PURE__*/_react.default.createElement("path", {
    d: "M8.643.75l-.106.008a.75.75 0 00-.518.326L5.996 4.118H3.029A3.002 3.002 0 00.034 7.114v12.35a2.996 2.996 0 002.995 2.996h17.965a2.996 2.996 0 002.995-2.996V7.114l-.005-.176a2.996 2.996 0 00-2.99-2.82h-2.968l-2.022-3.034A.75.75 0 0015.38.75H8.643zm.4 1.5h5.935L17 5.284a.75.75 0 00.624.334h3.369c.826 0 1.495.67 1.495 1.496v12.35c0 .826-.67 1.496-1.495 1.496H3.029c-.826 0-1.495-.67-1.495-1.496V7.114c0-.821.675-1.496 1.495-1.496h3.369l.106-.007a.75.75 0 00.518-.327L9.044 2.25z"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M12.011 7.487a5.241 5.241 0 100 10.482 5.241 5.241 0 000-10.482zm0 1.5a3.741 3.741 0 110 7.482 3.741 3.741 0 010-7.482z"
  }));
};

const ForwardRef = /*#__PURE__*/_react.default.forwardRef((props, ref) => /*#__PURE__*/_react.default.createElement(IconCamera, (0, _extends2.default)({
  svgRef: ref
}, props)));

var _default = ForwardRef;
exports.default = _default;